import React from 'react';
import { SxProps } from '@mui/material';
import StyledMaxWidthPageImage from './styled';

interface PropsType extends React.ImgHTMLAttributes<HTMLImageElement> {
	sx?: SxProps;
}

function MaxWidthPageImage({ sx, ...props }: PropsType) {
	return <StyledMaxWidthPageImage sx={sx} {...props} />;
}

export default MaxWidthPageImage;
